import { render, staticRenderFns } from "./app.mpx?vue&type=template&id=4d4f13ca&isApp"
import script from "./app.mpx?vue&type=script&lang=ts&isApp"
export * from "./app.mpx?vue&type=script&lang=ts&isApp"
import style0 from "./app.mpx?vue&type=style&index=0&id=4d4f13ca&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22mpx-app-scope%22%7D&isApp"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports